import { GQLTags } from "@gql/types/gql";
import Link from "@components/shared/linkNoPrefetch";
import { useQuery } from "@tanstack/react-query";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import style from "./style.module.scss";
export default function RelatedTags({
    tags,
    isNews = false,
}: {
    tags: GQLTags[];
    isNews?: boolean;
}) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <section className="sm:my-36 my-20 ">
            <h3 className="sm:text-3xl text-xl leading-10 font-bold">
                {translate(translations, "several_blogPostPage_relatedTopics")}
            </h3>
            <div className=" flex flex-row flex-wrap gap-3 sm:mt-5 mt-3">
                {tags?.map((el) => (
                    <Link
                        key={el.id}
                        href={`/${isNews ? "news" : "blog"}/tag/${
                            el.slug as string
                        }`}
                        className={`${style["linkStyle"]}`}
                    >
                        {el.name}
                    </Link>
                ))}
            </div>
        </section>
    );
}
